import Vue from 'vue'

export default {
  validate (giftCardCode, eventId) {
    var params = `code=${giftCardCode}&event_id=${eventId}`
    return Vue.prototype.$http.get(`/public_access/gift_card_codes/validate_code?${params}`)
  }
}
